export default {
  primary: {
    main: '#4385f7',
  },
  secondary: {
    main: '#ec5043',
  },
  text: {
    primary: "#768089",
    secondary: "rgba(0, 0, 0, 0.54)",
    disabled: "rgba(0, 0, 0, 0.38)",
    hint: "rgba(0, 0, 0, 0.38)",
  },
  blue: {
    light: '#81b4ff',
    main: '#4385f7',
    dark: '#0059c3',
  },
  green: {
    light: '#71de87',
    main: '#3bab59',
    dark: '007b2d',
  },
  yellow: {
    light: '#fff252',
    main: '#fdc00d',
    dark: '#c59000',
  },
  red: {
    light: '#ff836f',
    main: '#ec5043',
    dark: '#b3131a',
  },
  purple: {
    light: '#d05ce3',
    main: '#9c27b0',
    dark: '#6a0080',
  },

  pipeline: {
    match: '#e8f8ec',
    group: '#f6e6f9',
    sort: '#fef8e5',
  },
};
